<div
  class="menu-item"
  [id]="idx + '__' + item.code"
  [class.menu-item-expanded]="menuExpanded"
  [class.first-element]="item.code === 'nest' && isFirstElement"
  [class.first-agency-element]="isFirstElement && isAgencyPlatform"
  (click)="onItemSelected(item)"
>
  <span
    class="item-display-name"
    [style.visibility]="menuExpanded ? 'hidden' : 'visible'"
    [class.item-display-name--expanded]="menuExpanded"
    >{{ item.displayName }}</span
  >
  @if (isLastElement && itemListLength > 2) {
    <div class="line"></div>
  }

  <div class="item" [class.nest-item]="item.code === 'nest'" [class.menu-expanded]="menuExpanded">
    <div
      [class]="item.iconName"
      [class.icon]="true"
      [class.active]="isActive(item, currentUrl)"
      [class.menu-expanded]="menuExpanded && item.code === 'nest'"
    ></div>
    <div
      class="display-name item-display-name"
      [class.active]="isActive(item, currentUrl)"
      [class.nest-item]="item.code === 'nest'"
      [class.item-display-name--expanded]="menuExpanded"
    >
      {{ item.displayName }}
    </div>
  </div>
  @if (item?.hasFilterCount && filterCount > 0) {
    <div class="filter-count"></div>
  }
  @if (item.code === 'filters' && itemListLength > 2) {
    <div>
      <div class="line"></div>
    </div>
  }
</div>
